<template lang="pug">
  .preloader(:class="{ 'preloader_hidden' : !$preloader.show}")
    img(src="@/assets/img/global/preloader.svg" alt="")
</template>

<script>
export default {
  name: 'Preloader'
}
</script>
